export default "__VITE_ASSET__CjKmhwDB__"